"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ShopController_js_1 = require("./ShopController.js");
exports.ShopController = ShopController_js_1.ShopController;



//////////////////
// WEBPACK FOOTER
// ./scripts/apps/shop/controllers/index.ts
// module id = 353
// module chunks = 0